export const GET_INDUSTRYS = "GET_INDUSTRYS";
export const ADD_INDUSTRY = "ADD_INDUSTRY";
export const EDIT_INDUSTRY = "EDIT_INDUSTRY";
export const GET_INDUSTRY = "GET_INDUSTRY";
export const RESET_INDUSTRY = "RESET_INDUSTRY";
export const ERROR_INDUSTRY = "ERROR_INDUSTRY";
export const GET_ALL_INDUSTRYS = "GET_ALL_INDUSTRYS";
            